import React from 'react';
import ReactDOM from 'react-dom/client';

import App from 'App';
import { swRegister } from 'serviceWorker';
import 'assets/styles/main.scss';

const root = ReactDOM.createRoot(document.getElementById('qtrack'));

root.render(<App />);

swRegister();
